<div class="media-details">
  <div *ngIf="media.value.id === 0 && !editMode" class="empty-details">
    <span class="material-icons-outlined">perm_media</span>
  </div>

  <div *ngIf="media.value.id !== 0 || editMode" class="media-info-container">
    <div *ngIf="media.value.id !== 0 && !editMode" class="media-info">
      <table>
        <tr>
          <td>
            <button
              class="btn-download"
              (click)="downloadMedia()"
              [disabled]="isDownloading"
            >
              <ng-container *ngIf="!isDownloading && !downloadComplete">
                <span class="material-icons">download</span>
              </ng-container>
              <ng-container *ngIf="isDownloading">
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
              </ng-container>
              <ng-container *ngIf="downloadComplete && !isDownloading">
                <span class="material-icons text-success">check</span>
              </ng-container>
            </button>
          </td>
          <td class="value">
            {{ media.value.name }}
          </td>
        </tr>
        <tr>
          <div class="download-status">
            <p *ngIf="isDownloading" class="text-info">
              {{ "mediaDetails.downloadingMessage" | translate }}
            </p>
            <p *ngIf="downloadComplete && !isDownloading" class="text-success">
              {{ "mediaDetails.downloadCompleteMessage" | translate }}
            </p>
          </div>
        </tr>
        <tr
          *ngIf="isImage(media.value.contentType) && media.value.fileInfo?.path"
          style="display: table-row"
        >
          <td colspan="2">
            <img
              [src]="imageUrl | async"
              alt="Media Preview"
              class="media-image"
              (click)="openImageModal()"
            />
          </td>
        </tr>

        <tr>
          <td>
            <strong>{{ "mediaDetails.remarkLabel" | translate }}:</strong>
          </td>
          <td class="value">{{ media.value.remark }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "mediaDetails.uploadedByLabel" | translate }}:</strong>
          </td>
          <td class="value">{{ media.value.uploadedBy }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "mediaDetails.archivedLabel" | translate }}:</strong>
          </td>
          <td class="value">{{ media.value.archived }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "mediaDetails.fileInfoLabel" | translate }}:</strong>
          </td>

          <td class="value">{{ media.value.fileInfo?.fileName }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "mediaDetails.contentTypeLabel" | translate }}:</strong>
          </td>
          <td class="value">{{ media.value.contentType }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "mediaDetails.extensionLabel" | translate }}:</strong>
          </td>
          <td class="value">{{ media.value.extension }}</td>
        </tr>
        <tr>
          <td>
            <strong>{{ "mediaDetails.originalLabel" | translate }}:</strong>
          </td>
          <td class="value">{{ media.value.original }}</td>
        </tr>
      </table>
      <div
        class="modal-overlay"
        *ngIf="isModalOpen"
        (click)="closeImageModal()"
      >
        <div class="modal-content" (click)="$event.stopPropagation()">
          <img [src]="modalImage" alt="Full Image" class="modal-image" />
          <button class="close-button" (click)="closeImageModal()">
            &times;
          </button>
        </div>
      </div>
      <div class="btn">
        <button class="btn-edit" (click)="toggleEditMode()">
          <span class="material-icons-outlined">edit</span>
          {{ "mediaDetails.editButton" | translate }}
        </button>
        <button class="btn-delete" (click)="deleteMedia()">
          <span class="material-icons-outlined">delete</span>
          {{ "mediaDetails.deleteButton" | translate }}
        </button>
      </div>
    </div>

    <form [formGroup]="mediaForm" *ngIf="editMode">
      <div class="form-group">
        <input
          #fileInput
          type="file"
          accept="image/*"
          capture="camera"
          (change)="onFileSelected($event)"
        />
      </div>
      <action-button
        class="btn-save"
        (actionEvent)="saveMedia($event)"
        label="➤ "
      >
      </action-button>
      <div class="form-group" *ngIf="selectedFile">
        <input class="name" type="text" id="name" formControlName="name" />
        <messages
          class="msg"
          [form]="mediaForm"
          [messagesObserver]="messages"
          fieldname="name"
        ></messages>
      </div>

      <messages
        class="message"
        [form]="mediaForm"
        [messagesObserver]="messages"
        [showNonFieldKeys]="TRUE"
        [showFieldName]="TRUE"
        [showFieldKeys]="FALSE"
      ></messages>
    </form>
  </div>
</div>
